import { Platform } from 'react-native';

interface BiometricSupportResult {
  isAvailable: boolean;
  isEnrolled: boolean;
  supportedTypes: string[];
}

let cachedResult: BiometricSupportResult | null = null;
let cacheInitialized = false;
let inflightPromise: Promise<BiometricSupportResult> | null = null;

export const biometricSupportCache = {
  getCachedResult: (): BiometricSupportResult | null => {
    return cachedResult;
  },

  setCachedResult: (result: BiometricSupportResult): void => {
    console.log('🔐 [BiometricCache] Setting cached result:', {
      isAvailable: result.isAvailable,
      isEnrolled: result.isEnrolled,
      supportedTypes: result.supportedTypes,
      platform: Platform.OS
    });
    cachedResult = result;
    cacheInitialized = true;
  },

  isCacheInitialized: (): boolean => {
    return cacheInitialized;
  },

  clearCache: (): void => {
    console.log('🔐 [BiometricCache] Clearing cache');
    cachedResult = null;
    cacheInitialized = false;
    inflightPromise = null;
  },

  getOrFetch: async (
    fetchFunction: () => Promise<BiometricSupportResult>
  ): Promise<BiometricSupportResult> => {
    if (cacheInitialized && cachedResult !== null) {
      console.log('🔐 [BiometricCache] ✅ Returning cached result (no native calls)');
      return cachedResult;
    }

    if (inflightPromise) {
      console.log('🔐 [BiometricCache] ⏳ Awaiting in-flight check (deduped)');
      return inflightPromise;
    }

    console.log('🔐 [BiometricCache] ⚡ Cache miss - performing native biometric check (ONCE per session)');
    inflightPromise = fetchFunction().then(result => {
      biometricSupportCache.setCachedResult(result);
      inflightPromise = null;
      return result;
    }).catch(err => {
      inflightPromise = null;
      throw err;
    });

    return inflightPromise;
  }
};
